var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('core-background'),(_vm.auth.authenticated)?_c('core-drawer'):_vm._e(),_c('core-view'),_c('core-messages')],1)}
var staticRenderFns = []

export { render, staticRenderFns }